import { render, staticRenderFns } from "./totalResume.vue?vue&type=template&id=76cd8ffd&scoped=true&"
import script from "./totalResume.vue?vue&type=script&lang=js&"
export * from "./totalResume.vue?vue&type=script&lang=js&"
import style0 from "./totalResume.vue?vue&type=style&index=0&id=76cd8ffd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cd8ffd",
  null
  
)

export default component.exports